(() => {
  const sections = document.querySelectorAll('.home-pointer-gallery');

  sections.forEach((section) => {
    const slides = Array.from(section.querySelectorAll('.home-pointer-gallery__slide'));
    if (!slides.length) return;
    let activeIndex = 0;

    const syncLogoTheme = (index) => {
      const activeSlide = slides[index];
      const isDark = activeSlide?.dataset.logoTheme === 'dark';
      section.classList.toggle('is-logo-dark', isDark);
      section.classList.toggle('is-logo-light', !isDark);
    };

    const syncSlideVideos = (index) => {
      slides.forEach((slide, slideIndex) => {
        const video = slide.querySelector('video');
        if (!video) return;

        if (slideIndex === index) {
          video.muted = true;
          const playPromise = video.play();
          if (playPromise?.catch) {
            playPromise.catch(() => {});
          }
        } else {
          video.pause();
        }
      });
    };

    const setActiveSlide = (index) => {
      if (index === activeIndex) {
        syncLogoTheme(index);
        syncSlideVideos(index);
        return;
      }
      slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-revealed', slideIndex <= index);
        slide.classList.toggle('is-active', slideIndex === index);
      });
      activeIndex = index;
      syncLogoTheme(index);
      syncSlideVideos(index);
    };

    syncLogoTheme(activeIndex);
    syncSlideVideos(activeIndex);

    const updateFromPointer = (clientX) => {
      const bounds = section.getBoundingClientRect();
      if (!bounds.width) return;

      const boundedX = Math.max(bounds.left, Math.min(clientX, bounds.right));
      const ratio = (boundedX - bounds.left) / bounds.width;
      const index = Math.min(slides.length - 1, Math.floor(ratio * slides.length));
      setActiveSlide(index);
    };

    // Preload slide media aggressively so pointer scrubbing feels immediate.
    slides.forEach((slide) => {
      const image = slide.querySelector('img');
      if (image?.currentSrc || image?.src) {
        const preloadImage = new Image();
        preloadImage.src = image.currentSrc || image.src;
      }

      const video = slide.querySelector('video');
      if (video) {
        video.preload = 'auto';
        // Trigger buffering early without user interaction.
        video.load();
      }
    });

    let autoPlayInterval;

    const setupMobileAutoplay = () => {
      if (window.innerWidth <= 768) {
        if (!autoPlayInterval) {
          autoPlayInterval = setInterval(() => {
            const nextIndex = (activeIndex + 1) % slides.length;
            setActiveSlide(nextIndex);
          }, 1000);
        }
      } else {
        if (autoPlayInterval) {
          clearInterval(autoPlayInterval);
          autoPlayInterval = null;
        }
      }
    };

    setupMobileAutoplay();
    window.addEventListener('resize', setupMobileAutoplay);

    section.addEventListener('mousemove', (event) => {
      if (window.innerWidth > 768) {
        updateFromPointer(event.clientX);
      }
    });
  });

  const form = document.getElementById('HomePointerKlaviyoForm');
  const emailInput = document.getElementById('HomePointerEmail');
  const defaultContent = document.getElementById('HomePointerDefaultContent');
  const successContent = document.getElementById('HomePointerSuccessContent');
  const errorContainer = document.getElementById('HomePointerError');
  const newsletter = document.querySelector('[data-home-pointer-newsletter]');
  const newsletterClose = document.querySelector('[data-home-pointer-newsletter-close]');
  const newsletterStorageKey = 'acciHomePointerNewsletterClosed';

  if (newsletter) {
    try {
      if (window.localStorage.getItem(newsletterStorageKey) === 'true') {
        newsletter.classList.add('is-hidden');
      }
    } catch (error) {
      // Ignore storage failures so the newsletter remains usable.
    }

    if (!newsletter.classList.contains('is-hidden')) {
      const isDesktopHover = () => window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      const enableGlobalFade = () => {
        if (!isDesktopHover()) return;
        document.body.classList.add('fade-global');
      };
      const disableGlobalFadeWhenInactive = () => {
        if (document.getElementById('acci-cart-drawer')?.classList.contains('is-open')) return;
        if (!isDesktopHover()) {
          if (!document.querySelector('.acci-shop__filter-wrap.is-open, .lookbook-viewer__credits-wrap.is-open')) {
            document.body.classList.remove('fade-global');
          }
          return;
        }
        if (
          !document.querySelector(
            '.acci-nav .acci-nav__item:hover, .acci-nav .acci-nav__item:focus-within, .acci-shop__filter-wrap:hover, .acci-shop__filter-wrap:focus-within, .acci-shop__filter-wrap.is-open, .acci-header__right:hover, .acci-header__right:focus-within, [data-home-pointer-newsletter]:hover, [data-home-pointer-newsletter]:focus-within'
          )
        ) {
          document.body.classList.remove('fade-global');
        }
      };

      newsletter.addEventListener('mouseenter', enableGlobalFade);
      newsletter.addEventListener('mouseleave', disableGlobalFadeWhenInactive);
      newsletter.addEventListener('focusin', enableGlobalFade);
      newsletter.addEventListener('focusout', () => {
        requestAnimationFrame(disableGlobalFadeWhenInactive);
      });
    }
  }

  if (newsletter && newsletterClose) {
    newsletterClose.addEventListener('click', () => {
      newsletter.classList.add('is-hidden');
      document.body.classList.remove('fade-global');
      try {
        window.localStorage.setItem(newsletterStorageKey, 'true');
      } catch (error) {
        // Ignore storage failures so the close button still works for this page.
      }
    });
  }

  if (form) {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      
      const email = emailInput.value.trim();
      if (!email) return;

      const companyId = form.dataset.klaviyoKey;
      const listId = form.dataset.klaviyoList;

      if (!companyId || !listId) {
        errorContainer.textContent = 'Klaviyo configuration is missing in theme settings.';
        errorContainer.style.display = 'block';
        return;
      }

      const options = {
        method: 'POST',
        headers: {
          accept: 'application/json',
          revision: '2024-02-15',
          'content-type': 'application/json'
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Home Pointer Gallery',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email
                  }
                }
              }
            },
            relationships: {
              list: {
                data: {
                  type: 'list',
                  id: listId
                }
              }
            }
          }
        })
      };

      try {
        const response = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${companyId}`, options);
        if (response.ok || response.status === 202) {
          defaultContent.style.display = 'none';
          successContent.style.display = 'block';
          errorContainer.style.display = 'none';
        } else {
          const errData = await response.json();
          throw new Error(errData.errors?.[0]?.detail || 'Subscription failed. Please try again.');
        }
      } catch (err) {
        errorContainer.textContent = err.message;
        errorContainer.style.display = 'block';
      }
    });
  }
})();
